$(function(){
	$(document.body).on('show.bs.modal', function () {
		$('.modal .modal-body').css('overflow-y', 'auto'); 
		$('.modal .modal-body').css('max-height', $(window).height() * 0.7);
	});
	$(document.body).on('shown.bs.modal', function () {
		// Lorsqu'on ouvre une fen�tre modal, on recherche le premier champ disponible et on lui donne le focus
		// Si c'est le popup pour entrer un temps via la grille de saisie
		if ($(this).find(".modal").hasClass("work-input-grid-modal")) {
			$("input[name=work_time]").focus().select(); // On met le focus sur le champs Temps
		} else {
			$('.modal-body form:not(.filter) :input:not([readonly]):visible:enabled:first:not(.no-focus)').focus();
		}
	});

	// Début validation email
	jQuery.validator.addMethod("email2", function (value, element) {
		var regex = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
		return value.trim() == "" || regex.exec(value) !== null;
	});
	// Fin validation email
	addJQueryCompareMethods();
});
$(document).ajaxStart(function() { Pace.restart(); });
$(document).submit(function() { Pace.restart(); });

// comparer les dates avec moment.js
window.addJQueryCompareDateMethods = function(date_placeholder_format) {
	date_placeholder_format = date_placeholder_format.toUpperCase();
	jQuery.validator.addMethod("greaterOrEqualToDate", function (value, element, params) {
		value = moment(value, date_placeholder_format).format("YYYY-MM-DD");
		params = moment($(params).val(), date_placeholder_format).format("YYYY-MM-DD");
		if (!/Invalid|NaN/.test(new Date(value)) && !/Invalid|NaN/.test(new Date(params))) {
			return new Date(value) >= new Date(params);
		}
		return true;
	}, "Date n'est pas valide");

	jQuery.validator.addMethod("smallerOrEqualToDate", function (value, element, params) {
		value = moment(value, date_placeholder_format).format("YYYY-MM-DD");
		params = moment($(params).val(), date_placeholder_format).format("YYYY-MM-DD");
		if (!/Invalid|NaN/.test(new Date(value)) && !/Invalid|NaN/.test(new Date(params))) {
			return new Date(value) <= new Date(params);
		}
		return true;
	}, "Date n'est pas valide");
}

// comparer les nombres
window.addJQueryCompareMethods = function() {
	jQuery.validator.addMethod("greaterOrEqualTo", function (value, element, params) {
		params = $(params).val();
		return isNaN(value) && isNaN(params) || (Number(value) >= Number(params));
	}, "Nombre n'est pas valide");

	jQuery.validator.addMethod("smallerOrEqualTo", function (value, element, params) {
		params = $(params).val();
		return isNaN(value) && isNaN(params) || (Number(value) <= Number(params));
	}, "Nombre n'est pas valide");
}

// prévenir la fermeture d'onglet
window.hasUnsavedChanges = false;
window.toggleWarn = function(b){
	window.hasUnsavedChanges = b;
	if(b){
		window.onbeforeunload = function(e)
		{
			return "Save changes?";
		};
	}
	else{
		window.onbeforeunload = null;
	}
}

// rediriger vers la page de login si pas de session
$(document).ajaxComplete(function (event, xhr, settings) {
	var res = xhr.responseText;
	if (res.length > 0 && res.charAt(0) == "{") {
		var json = JSON.parse(res);
		if (json.session_died != null && json.session_died == 1) {
			$("body").html("");
			var redirection_path = json.redirect_path;
			window.location.href = redirection_path;
		}
	}
});

// Fonction pour rafraichir une datatable
window.refreshTable = function(id, html) {
	$("#" + id).html(html);
	$("#" + id + " .tooltips").tooltip(); // On recharge les tooltips
	// On v�rifie si l'�l�ment a la classe scroller, si c'est le cas, on le r�initialise pour fixer la hauteur
	if ($("#" + id).hasClass("scroller")) {
		var max_height = $("#" + id).css("max-height"); // On note la hauteur maximale avant de le d�truire puisque �a va supprimer l'attribut
		App.destroySlimScroll($("#" + id)); // On d�truit le scroller
		$("#" + id).css("max-height", max_height); // On remet la hauteur maximale
		App.initSlimScroll($("#" + id)); // On initialise le scroller
	}
	// si la table ne fait pas partie des tabs
	if ($("#" + id).closest(".portlet").find(".nav-tabs").length==0) {
		var row = $("#" + id).parents("div.row").last(); // On trouve la ligne la plus �loign�e dans les parents
		adjustPortletsHeights(row); // On ajuste la hauteur des portlets		
	}
}

// Fonction pour ajuster la hauteur des bo�tes (portlets) d'une m�me ligne (row), on prend la hauteur maximale
window.adjustPortletsHeights = function(rows) {
	var rows = rows || $("body").find("div.row");
	// On trouve toutes les lignes qui contiennent au moins deux portlets
	rows.filter(function() { return $(this).find("div.portlet").length > 1; }).each(function() {
		// On commence par r�initialiser la hauteur du portlet
		$(this).find("div.portlet").css("height", "auto");		
		// On trouve la hauteur maximale entre les divs enfants
		var max_height = Math.max.apply(null, $(this).find("div.portlet").map(function () { return $(this).height(); }).get());
		$(this).find("div.portlet").css("height", max_height); // On change la hauteur pour que tous les portlets de la m�me row aient la m�me hauteur
	});
}

// fonction pour unifier les bootbox de confirmation
window.customBootboxConfirmation = function(main_title,title,explication,question,buttons,class_name){
	var title_content = "<div class='bootbox-main-title'>"+main_title+"</div>";
	var message_content = "<div class='bootbox-content-title'>"+title+"</div>";
	message_content += "<div class='bootbox-content-message'>"+explication+"</div>";
	message_content += "<div class='bootbox-content-question'>"+question+"</div>";
	var my_bootbox = bootbox.dialog({ 
		className: class_name,
		title: title_content,
		message: message_content,
		buttons: buttons
	});

	my_bootbox.on("shown.bs.modal", function() {
		var modal_body = $("."+class_name).find(".modal-body");
		var modal_body_height = modal_body.height();

		var height_title = modal_body.find(".bootbox-content-title").height();
		var height_message = modal_body.find(".bootbox-content-message").height();
		var height_question = modal_body.find(".bootbox-content-question").height();

		// limiter l'hauteur visible de l'explication si trop grande
		var height_visible_min = 60;
		var height_visible = height_message;
		if ((height_title + height_message + height_question) > modal_body_height) {
			if ((height_title + height_question + height_visible_min) > modal_body_height) {
				height_visible = height_visible_min;
			}
			else{
				height_visible = modal_body_height - (height_title + height_question);
			}
		}
		// afficher la partie avec la question
		modal_body.scrollTop(height_title + height_visible + height_question);
		modal_body.find(".bootbox-content-message").css("height",height_visible+"px");

	});

}

// fonction pour initialiser les footables
window.initFootable = function(id_table, breakpoints) {

	var table = undefined;
	if(typeof(id_table) === 'string'){
		table = $("#" + id_table);
	}
	else{
		table = id_table;
	}

	var empty_msg = table.data("footable-empty-message");
	if (typeof empty_msg === "undefined" || empty_msg === null) {
		empty_msg = "Aucun résultat";
	}
	var options = {
		"breakpoints": breakpoints,
		"empty": empty_msg,
		"toggleSelector": "tbody tr:not(.footable-detail-row) .footable-first-visible, tbody tr:not(.footable-detail-row) .footable-first-visible *:not(.selector-element-checkbox)",
	};
	if (breakpoints != "") {
		table.footable(options, initFootableEvents);
	}
	else {
		options["breakpoints"] = {
			"xs": 480, // extra small
			"sm": 768, // small
			"md": 992, // medium
			"lg": 1200, // large
			"xlg": 1400, // x-large
			"xxlg": 1600 // xx-large
		}
		table.footable(options, initFootableEvents);
	}
	table.find(".tooltips").tooltip();
}

// fonction pour initialiser les évènement des footables
window.initFootableEvents = function(footable) {
	var body = footable.$el.find('tbody');
	footable.$el.find('tbody tr :first-child').on('mouseenter', function(event) {
		var isExpandable = $('#'+footable.$el.attr('id')+' thead tr th').filter(function(index, col) {
			return $(col).css('display') == 'none';
		}).length > 0;
		if (isExpandable) {
			$(body).addClass('expandable');
		} else {
			$(body).removeClass('expandable');
		}
	});
}

// fonction pour mettre � jour la ligne dans une table
window.refreshTableTr = function(id_table,id_tr,tr,footable_breakpoints){
	$("#"+id_table).find("tr.selected").removeClass("selected");

	if ($("#"+id_table).hasClass("footable")) {
		var y = window.pageYOffset;	
		var expanded = $("#"+id_tr).data("expanded");
		$("#"+id_tr).replaceWith(tr);
		initFootable(id_table,footable_breakpoints);
		initDescriptionCells(id_table);
		window.scrollTo(0, y);
		if (expanded == true) {
			// d�velopper la ligne de footable
			$("#"+id_tr).trigger('click');
		}
	}
	else{
		$("#"+id_tr).replaceWith(tr);
		initDescriptionCells(id_table);
	}
}

// fonction pour afficher/cacher le contenu des cellules dans les tables
window.initDescriptionCells = function(id_table){
	$("#"+id_table).find(".td-description").each(function(){
		var content = $(this).html();
		var max_height = $(this).data("max-height");
		if (content != "") {
			var height = $(this).outerHeight();
			if (height >= max_height) {
				var container = $("#tpl_description").clone();
				container.css("height",max_height+"px");
				container.removeAttr("id");
				container.find(".description-content").append(content);
				$(this).html(container);
				$(this).find(".tooltips").tooltip();
			}
		}
	});

	$("#"+id_table).off("click",".action-description-show");
	$("#"+id_table).on("click",".action-description-show",function(){
		$(this).fadeOut(function(){
			var descr = $(this).closest(".description-container");
			descr.find(".action-description-hide").fadeIn();
			var cont_height = descr.find(".description-content").height();
			descr.animate({ height:cont_height });		
		});
	});
	$("#"+id_table).off("click",".action-description-hide");
	$("#"+id_table).on("click",".action-description-hide",function(){
		$(this).fadeOut(function(){
			var descr = $(this).closest(".description-container");
			var max_height = $(this).closest(".td-description").data("max-height");
			descr.find(".action-description-show").fadeIn();
			descr.animate({ height:max_height });		
		});
	});
}

/**
 * Fonction pour traiter l'erreur AJAX/XHR.
 */
window.processXHRError = function(jqXHR, textStatus, thrownErr) {
	if (jqXHR.status === 400) {
		var resp_text = JSON.parse(jqXHR.responseText);
		toastr.error(resp_text.msg, thrownErr);
	}
	else {
		toastr.error(jqXHR.responseText, thrownErr);
	}
}

/**
 * Fonction pour traiter le popup selon la réponse du serveur.
 */
window.processPopupServerResponse = function(bootboxPopup, success) {
	if (success) {
		bootboxPopup.modal('hide');
	}
	else {
		$(".submit-btn").prop("disabled", false);
		$(".submit-btn").removeClass("disabled");
	}
}